import {remote} from '../constants/environment';
import {IListOption} from '../interfaces/globals';
import {IEntitiesResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const getEntities = async (): Promise<IEntitiesResponse> => {
  const remoteURI = remote.getEntitiesUri();
  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: defaultHeaders,
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as IListOption[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IEntitiesResponse;
};
